import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";

import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import { UserCard } from "components/UserCard/UserCard.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import axios from "axios";
import avatar from "assets/img/faces/face-3.jpg";
import { base_url } from "../../redux/constants/routes";

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: undefined,
      password: undefined,
    };
    this.doLogin = this.doLogin.bind(this);
    this.changePassword = this.changePassword.bind(this);
    this.changeUsername = this.changeUsername.bind(this);
  }

  changePassword(e) {
    this.setState({ password: e.target.value });
  }

  changeUsername(e) {
    this.setState({ username: e.target.value });
  }

  doLogin = () => {
    console.log(base_url + "/login");
    if (this.state.username && this.state.password) {
      axios
        .post(base_url + "/login", {
          username: this.state.username,
          password: this.state.password,
        })
        .then((res) => {
          console.log(res.data.token);
          localStorage.setItem("token", res.data.token);
          axios.defaults.headers.common["Authorization"] = res.data.token;
          console.log(axios.defaults.headers.common);
          window.location.href = "/";
        })
        .catch((err) => {
          console.log(err);
          window.location.href = "/";
        });
    }
  };

  render() {
    return (
      <Grid fluid style={{ marginTop: "30px", height: "85% !important" }}>
        <Row>
          <Col
            md={6}
            style={{
              marginRight: "auto",
              marginLeft: "auto",
              float: "none",
            }}
          >
            <Card
              title="ورود به سیستم"
              content={
                <form>
                  <Row>
                    <Col xs={12}>
                      <FormGroup>
                        <ControlLabel>نام کاربری</ControlLabel>
                        <FormControl
                          type="text"
                          bsClass="form-control"
                          placeholder="نام کاربری"
                          inputRef={(ref) => {
                            this.username = ref;
                          }}
                          defaultValue={this.state.username}
                          onChange={this.changeUsername}
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={12}>
                      <FormGroup>
                        <ControlLabel>رمز عبور</ControlLabel>
                        <FormControl
                          type="password"
                          bsClass="form-control"
                          placeholder="رمز عبور"
                          inputRef={(ref) => {
                            this.password = ref;
                          }}
                          defaultValue={this.state.password}
                          onChange={this.changePassword}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button
                    bsStyle="info"
                    onClick={this.doLogin}
                    pullRight
                    fill
                    type="button"
                  >
                    ورود
                  </Button>
                  <div className="clearfix" />
                </form>
              }
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}
